export default function getOrgName(org) {
  return org.display_name ?? org.name ?? '';
}
